import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';
import { ChecklistTemplateDto } from 'src/types/checklist-template.types';

export class ChecklistTemplateApi {
  private axiosInstance: AxiosInstance;

  constructor(configuration: Configuration) {
    this.axiosInstance = axios.create({
      baseURL: configuration.basePath ?? '',
      ...configuration.baseOptions,
    });
  }

  async findAll(): Promise<ChecklistTemplateDto[]> {
    const { data } = await this.axiosInstance.get<ChecklistTemplateDto[]>('/checklist-templates');
    return data;
  }
}
